import * as Yup from "yup";

import { basicEntityFromJson, IBasicEntity } from "../../../core/models";

interface IExpenseBase {
  name: string;
}

export interface IExpense extends IExpenseBase, IBasicEntity {}

export interface IExpenseForm extends IExpenseBase {}

const expenseCommonValidation = {
  name: Yup.string().required(),
};

export const expenseFormValidation = Yup.object<IExpenseForm>({
  ...expenseCommonValidation,
});

export const expenseEditFormValidation = Yup.object<IExpenseForm>({
  ...expenseCommonValidation,
});

export const expenseFromJson = (json: any): IExpense => {
  const e: IExpense = {
    ...basicEntityFromJson(json),
    name: json.name.toString(),
  };

  return e;
};

export const expenseToJson = (form: IExpenseForm) => {
  return {
    name: form.name.toString(),
  };
};
